<script setup lang="ts">
import { ref } from 'vue'
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import { T } from '@tolgee/vue'
import FingerUpImage from '@/assets/images/gifs/finger-up.gif'
import BaseToggle from '@/components/base/BaseToggle.vue'

defineProps<{
  show: boolean
}>()

const emit = defineEmits<{
  (e: 'hide'): void
  (e: 'doNotShowAgain'): void
}>()

const doNotShowAgain = ref(false)

function onHide() {
  if (doNotShowAgain.value) {
    emit('doNotShowAgain')
  }
  emit('hide')
}
</script>
<template>
  <TheBottomSheet
    :show="show"
    centered
    content-class="pt-6"
    container-class="max-w-[312px]"
    @hide="onHide"
  >
    <div class="w-full flex flex-col items-center">
      <div class="flex flex-col items-center">
        <h1 class="text-white multiplier-title text-[34px] leading-none font-bold text-center font-pilat px-4">
          <T
            key-name="fortune_wheel.multiplier_unlocked.title"
            default-value="Prize Multiplier"
          />
        </h1>
        <span class="text-[32px] font-bold golden-text-black-stroke -rotate-[6.316deg] -mt-1">
          <T
            key-name="fortune_wheel.multiplier_unlocked.subtitle"
            default-value="UNLOCKED!"
          />
        </span>
      </div>

      <div class="relative w-full flex items-center mt-6 -left-1/2 -ml-2">
        <div class="relative flex items-center w-full min-w-[298px]">
          <div class="spin-button-mock bg-red-accent rounded-xl h-[85px] w-full px-6 flex items-center justify-center gap-3 relative">
            <span class="text-white text-[28px] leading-[45px] font-bold">SPIN</span>
            <span class="text-white/[.87] text-[25px] leading-[35px] font-semibold">(503)</span>
          </div>
          <div class="multiplier-button-mock absolute -top-7 -right-7">
            <div class="size-[70px] rounded-full border-[3px] border-red-accent overflow-hidden">
              <div class="flex items-center justify-center w-full h-full rounded-full font-bold text-white/[.87] text-[30px] leading-9 bg-[#FFA500]">
                x10
              </div>
            </div>
          </div>
        </div>
        <img
          :src="FingerUpImage"
          class="absolute -right-[135px] top-1/2 -translate-y-1/4 size-[120px] -rotate-[35deg] pointer-events-none"
        >
      </div>

      <div class="flex flex-col items-center gap-y-2 mt-12">
        <p class="text-white/[.87] text-xl font-semibold text-center leading-6">
          <T
            key-name="fortune_wheel.multiplier_unlocked.description"
            default-value="Tap the new button to multiply your prizes instantly!"
          />
        </p>
      </div>

      <div class="flex flex-col items-center gap-y-1 mt-4">
        <p class="text-white/[.87] text-xs font-bold">
          <T
            key-name="fortune_wheel.multiplier_unlocked.note_1"
            default-value="Multiplier spends spins."
          />
        </p>
        <p class="text-white/[.87] text-xs font-bold">
          <T
            key-name="fortune_wheel.multiplier_unlocked.note_2"
            default-value="Only applies to in-game rewards."
          />
        </p>
        <p class="text-white/[.87] text-xs font-bold">
          <T
            key-name="fortune_wheel.multiplier_unlocked.note_3"
            default-value="Not valid for $DROPEE tokens."
          />
        </p>
      </div>

      <div
        class="flex items-center gap-x-3 mt-6"
        @click="doNotShowAgain = !doNotShowAgain"
      >
        <BaseToggle
          :is-active="doNotShowAgain"
          @on-toggle="doNotShowAgain = !doNotShowAgain"
        />
        <p class="text-white/[60] text-xs font-medium">
          <T
            key-name="fortune_wheel.multiplier_unlocked.do_not_show_again"
            default-value="Do not show again"
          />
        </p>
      </div>
    </div>
  </TheBottomSheet>
</template>
<style scoped>
.unlocked-text {
  text-shadow:
    -2px -2px 0 #000,
    2px -2px 0 #000,
    -2px 2px 0 #000,
    2px 2px 0 #000,
    -2px 0 0 #000,
    2px 0 0 #000,
    0 -2px 0 #000,
    0 2px 0 #000;
}

.multiplier-demo {
  position: relative;
}

.spin-button-mock {
  box-shadow: 0 4px 0 0 #7A1A1A;
}

.multiplier-title {
  -webkit-text-stroke-width: 2px;
  -webkit-text-stroke-color: rgba(255, 255, 255, 0.40);
}
.multiplier-subtitle {
  -webkit-text-stroke-width: 2px;
  -webkit-text-stroke-color: #000;
  background: linear-gradient(90deg, #FFF246 0%, #E5B80B 37%, #FFF571 68.5%, #E5B80B 100%);
}
</style>
